import { useSonner } from 'sonner';

export const useToasts = () => useSonner();
